"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _helpDocuments = require("@/api/helpDocuments/helpDocuments");
var _markdownPlus = require("@/assets/js/markdownPlus");
var _validate = require("@/utils/validate");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'helpDocuments',
  data: function data() {
    return {
      isCnLang: true,
      documentIDList: [],
      markdownOption: _markdownPlus.markdownOption,
      currentTab: 'userRegistrationNew',
      form: {
        title: undefined,
        content: ''
      },
      manualPath: this.$i18n.locale === "zh" ? "/helpManual/doc-cn.html" : "/helpManual/doc-en.html"
    };
  },
  created: function created() {
    this.isCnLang = this.$i18n.locale === 'zh';
    // getDictList().then(response => {
    //   this.documentIDList = response.data
    //   let currentID = this.documentIDList.filter(item => (item.label === (this.$i18n.locale === "zh" ? "zh-cn" : "en") && item.labelEn ==='userRegistrationNew'))[0].value
    //   this.getDocuments(currentID)
    // })
  },
  methods: {
    validateNull: _validate.validateNull,
    getDocuments: function getDocuments(id) {
      var _this = this;
      (0, _helpDocuments.getTechnicalDocumentsById)(id).then(function (response) {
        // alert(JSON.stringify(response))
        _this.form = response.data;
      });
    },
    handleSelect: function handleSelect(index) {
      var _this2 = this;
      this.currentTab = index;
      var currentID = this.documentIDList.filter(function (item) {
        return item.label === (_this2.$i18n.locale === "zh" ? "zh-cn" : "en") && item.labelEn === index;
      })[0].value;
      this.getDocuments(currentID);
    }
  }
};